// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.search-form .el-form-item--small.el-form-item[data-v-295a3650] {\n  margin-bottom: 5px;\n}\n", ""]);
// Exports
module.exports = exports;
